import { FunctionComponent } from 'react';
import './Ribbon.css';
import { useNavigate } from "react-router";
import { ToastUtility } from '@syncfusion/ej2-react-notifications';

import IMPORT_SRC from '../../Icons/import.svg';
import SYSTEM_SRC from '../../Icons/system.svg';
import USERS_SRC from '../../Icons/users.svg';
import OPERATIONS_SRC from '../../Icons/operations.svg';
import TOOLSETS_SRC from '../../Icons/toolsets.svg';
import RELMAP_SRC from '../../Icons/hierarchy.svg';
import { logger } from "../../utility/logger";

const Ribbon: FunctionComponent = () => {
    const navigate = useNavigate();
    const handleImportClick = (label: string) => () => {
    ToastUtility.show('Import Event Started.', 'Success', 1500);
    logger.log(`${label} clicked`);
  };
  const handleSystemClick = (label: string) => () => {
    navigate('/system');
    logger.log(`${label} clicked`);
  };
    const handleUsersClick = (label: string) => () => {
    navigate('/users');
    logger.log(`${label} clicked`);
  };
    const handleOperationsClick = (label: string) => () => {
    navigate('/operations');
    logger.log(`${label} clicked`);
  };
    const handleToolsetsClick = (label: string) => () => {
    navigate('/toolsets');
    logger.log(`${label} clicked`);
  };
    const handleRelationshipClick = (label: string) => () => {
    navigate('/hierarchical');
    logger.log(`${label} clicked`);
  };

  return (
    <div className="ribbon">
      
      <div className="settings-parent">
        <div className="sap">Settings</div>
        <div className="ribbon-link-parent">
          <button
            type="button"
            className="ribbon-link2"
            data-csm-step="ribbon.system"
            onClick={handleSystemClick('System')}
            aria-label="System"
          >
            <img className="import-icon" src={SYSTEM_SRC} alt="" />
            <div className="import">System</div>
          </button>

          <button
            type="button"
            className="ribbon-link"
            data-csm-step="ribbon.resources"
            onClick={handleOperationsClick('Operations')}
            aria-label="Operations"
          >
            <img className="import-icon" src={OPERATIONS_SRC} alt="" />
            <div className="import">Resources</div>
          </button>

                    <button
            type="button"
            className="ribbon-link"
            data-csm-step="ribbon.user"
            onClick={handleUsersClick('User')}
            aria-label="User"
          >
            <img className="import-icon" src={USERS_SRC} alt="" />
            <div className="import">User</div>
          </button>

          <button
            type="button"
            className="ribbon-link"
            data-csm-step="ribbon.toolsets"
            onClick={handleToolsetsClick('Toolsets')}
            aria-label="Toolsets"
          >
            <img className="import-icon" src={TOOLSETS_SRC} alt="" />
            <div className="import">Toolsets</div>
          </button>
        </div>
      </div>


      
    </div>
  );
};

export default Ribbon;